import React from "react";
import Toast, { type ToastProps } from "./Toast";

export interface ToastContainerProps {
	toasts: ToastProps[];
	onRemoveToast: (id?: string) => void;
}

const ToastContainer: React.FC<ToastContainerProps> = ({
	toasts,
	onRemoveToast,
}) => {
	if (toasts.length === 0) return null;

	return (
		<div className="fixed top-20 right-4 z-[9999] flex flex-col gap-2 pointer-events-none">
			{toasts.map((toast) => (
				<div key={toast.id || Math.random()} className="pointer-events-auto">
					<Toast {...toast} onClose={() => onRemoveToast(toast.id)} />
				</div>
			))}
		</div>
	);
};

export default ToastContainer;
